/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type WorkatoIntegration = "HiBob" | "%future added value";
export type StartRecipesInput = {|
  integration?: ?WorkatoIntegration,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type startRecipesMutationVariables = {|
  input: StartRecipesInput
|};
export type startRecipesMutationResponse = {|
  +startRecipes: ?{|
    +outcome: ?string
  |}
|};
export type startRecipesMutation = {|
  variables: startRecipesMutationVariables,
  response: startRecipesMutationResponse,
|};
*/


/*
mutation startRecipesMutation(
  $input: StartRecipesInput!
) {
  startRecipes(input: $input) {
    outcome
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "StartRecipesInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "StartRecipesPayload",
    "kind": "LinkedField",
    "name": "startRecipes",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "outcome",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "startRecipesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "startRecipesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "startRecipesMutation",
    "operationKind": "mutation",
    "text": "mutation startRecipesMutation(\n  $input: StartRecipesInput!\n) {\n  startRecipes(input: $input) {\n    outcome\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'cc07ad06f753abc5879ba3fc55608528';

module.exports = node;
